import { useGeneratePoiPdfMutation } from '@/__generated__/graphql';
import { createPdfLink, generateZipFile } from '@/utils';

export const useBulkReportDownload = ({
  selectedReportIds,
  selectedReportsMap,
  setLoading,
}: {
  selectedReportIds: string[];
  selectedReportsMap: Record<string, string>;
  setLoading: (loading: boolean) => void;
}) => {
  const [generatePoiPdf] = useGeneratePoiPdfMutation();
  const handleBulkDownload = async () => {
    setLoading(true);
    const { data } = await generatePoiPdf({
      variables: { reportIds: selectedReportIds },
    });
    if (data && data.generatePoiPdf.base64Data && data.generatePoiPdf.base64Data.length > 0) {
      // If there's only one PDF and one report selected, download it directly without zipping
      if (data.generatePoiPdf.base64Data.length === 1) {
        const base64Data = data.generatePoiPdf.base64Data.at(0);
        if (base64Data) {
          const byteCharacters = atob(base64Data);
          const byteNumbers = new Array(byteCharacters.length);
          for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
          }
          const byteArray = new Uint8Array(byteNumbers);
          const pdfBlob = new Blob([byteArray], { type: 'application/pdf' });
          // Download PDF
          const reportId = selectedReportIds.length > 0 ? selectedReportIds.at(0) : null;
          const reportName =
            reportId && selectedReportsMap[reportId] ? selectedReportsMap[reportId] : 'report';
          createPdfLink(pdfBlob, `${reportName}.pdf`);
        }
      } else {
        await generateZipFile(
          data?.generatePoiPdf?.base64Data,
          selectedReportIds,
          selectedReportsMap
        );
      }
    }
    setLoading(false);
  };
  return {
    handleBulkDownload,
  };
};
